export default "__VITE_ASSET__8NudI1Rd__"